export default __webpack_public_path__ + "static/media/ct.5ee380b6.gif";